module.exports = __webpack_public_path__ + "static/media/messageIcon.e97319f6.svg";